import { combineReducers } from 'redux';
import defaultReducer from 'redux/reducers/default';
import notificationReducer from 'redux/reducers/notification';

export default combineReducers({
  default: defaultReducer,
  notifications: notificationReducer
});
